import { render, staticRenderFns } from "./PurchaseOrderView.vue?vue&type=template&id=cf517d16&scoped=true"
import script from "./PurchaseOrderView.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderView.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderView.vue?vue&type=style&index=0&id=cf517d16&prod&lang=scss"
import style1 from "./PurchaseOrderView.vue?vue&type=style&index=1&id=cf517d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf517d16",
  null
  
)

export default component.exports